import React from "react";

import styled from "styled-components";

import { FormConfiguration } from "./FormConfiguration";
import { FormContext } from "./Utilities/FormContext";
import { Button, TextField } from "@mui/material";
import { CloseIcon } from "../CommonUI/Icon/CloseIcon";
import { FormMode } from "./Utilities/FormDesignConstants";
import { ExecutionData } from "../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { AppGlueCoreInit } from "../AppGlueCoreInit";
import type { AppGlueAny } from "../rule-engine-core/Common/AppGlueAny";

const Header = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 15px;
    bottom: 100%;
    left: 0;
    width: 100%;
    position: absolute;

    .MuiButtonBase-root {
        margin-left: auto;
    }
`;

export interface IUserFormParameters {
    form: FormConfiguration;
    formTitle?: string;
    formData?: ExecutionData;
    onFormDataChange?: (data: ExecutionData) => void;
    onFormButtonClick?: (buttonName: string, data: ExecutionData) => void;
    onFormCancelButton?: () => void;
    onFormClose?: (data: ExecutionData) => void;
}

export class FormRuntime extends React.Component<IUserFormParameters, AppGlueAny> {
    name?: string;

    constructor(props: IUserFormParameters) {
        super(props, {});
        // ensure controls are registered.
        AppGlueCoreInit.init();
    }

    hasHeader = (): boolean => {
        return !!this.props.formTitle || !!this.props.onFormClose;
    };

    render() {
        // make sure form context is setup correctly.
        let fContext = this.props.form.getFormContext() ?? new FormContext(this.props.form);
        fContext.mode = FormMode.Runtime;

        if (this.props.formData) fContext.setFormData(this.props.formData);

        if (this.props.onFormDataChange) fContext.onFormDataChange = this.props.onFormDataChange;

        if (this.props.onFormButtonClick) fContext.onFormButtonClick = this.props.onFormButtonClick;

        if (this.props.onFormCancelButton) fContext.onFormCancelButton = this.props.onFormCancelButton;

        if (this.props.onFormClose) fContext.onFormClose = this.props.onFormClose;

        if (this.props.formTitle) fContext.formTitle = this.props.formTitle;

        this.props.form.setFormContext(fContext);

        return (
            <>
                {this.hasHeader() && (
                    <Header>
                        {this.props.formTitle && (
                            <TextField
                                value={this.props.formTitle}
                                data-testid="test-form-title"
                            />
                        )}
                        {this.props.onFormClose && (
                            <Button
                                onClick={() => this.props.onFormClose!(this.props.form.getFormContext()!.getFormData())}
                                data-testid="btn-topbar-close"
                            >
                                <CloseIcon />
                            </Button>
                        )}
                    </Header>
                )}
                {this.props.form.render()}
            </>
        );
    }
}
